let push = ''
if (window.location.href.indexOf('doc.mding.org') > -1 ||
    window.location.href.indexOf('localhost') ||
    window.location.href.indexOf('127.0.0.1') > -1) {
  push = 'https://dev.push.mding.org/'
} else {
  push = 'https://tea.push.mding.org/'
}
if (window.location.href.indexOf('index.pub.html') > -1) {
  push = 'https://tea.push.mding.org/'
}
const DIC = {
  OSS: 'https://img.tea.mding.org/',
  PUSH: push,
  // PUSH: 'https://tea.push.mding.org/',
  // PUSH: 'http://127.0.0.1:3000/',
  SCREEN_WIDTH: window.screen.width,
  DEVICE_PIXEL_RATIO: window.devicePixelRatio > 1 ? 2 : 1,
  GOODS_STATUS: [
    { value: 0, label: '下架' },
    { value: 1, label: '上架' }
  ],
  GOODS_STATUS_OFF: 0,
  GOODS_STATUS_ON: 1,
  PAY_STATUS: [
    { value: 0, label: '未付款' },
    { value: 1, label: '已付款' }
  ],
  ORDER_SEARCH_STATUS: [
    { value: 0, label: '待处理' },
    { value: 1, label: '待发货' },
    { value: 2, label: '已发货' },
    { value: 3, label: '已完成' },
    { value: 4, label: '已取消' }
  ],
  ORDER_STATUS: [
    { value: '301', label: '待处理' },
    { value: '302', label: '待发货' },
    { value: '303', label: '待发货' },
    { value: '304', label: '已发货' },
    { value: '305', label: '已发货' },
    { value: '201', label: '已完成' },
    { value: '104', label: '已取消' }

  ],
  ORDER_RECORD_STATUS: [
    { value: '0', label: '下单' },
    { value: '1', label: '修改单据' },
    { value: '2', label: '删除单据' },
    { value: '3', label: '确认支付方式' },
    { value: '4', label: '付款' },
    { value: '5', label: '确认单据' },
    { value: '6', label: '开始送货' },
    { value: '7', label: '用户确认收货' },
    { value: '8', label: '配送确认付款' },
    { value: '9', label: '订单完成' },
    { value: '10', label: '用户删除/隐藏订单' }
  ],
  ORDER_STATUS_WAIT: '301',
  PICK_ORDER_STATUS: [
    { value: 0, label: '待处理' },
    { value: 1, label: '已派发' },
    { value: 2, label: '取货中' },
    { value: 3, label: '未完成' },
    { value: 4, label: '已完成' }
  ],
  PAY_CHANNEL: [
    { value: 0, label: '微信' },
    { value: 1, label: '支付宝' },
    { value: 2, label: '现金' }
  ],
  PAY_TYPE: [
    { value: 0, label: '线上支付' },
    { value: 1, label: '货到付款' }
  ],
  PICK_ORDER_STATUS_WAIT: 0,
  PICK_ORDER_STATUS_SEND: 1,
  PICK_ORDER_STATUS_PICK: 2,
  PICK_ORDER_STATUS_FAIL: 3,
  PICK_ORDER_STATUS_SUCCESS: 4
}
if (window.location.href.indexOf('index.pub.html') > -1) {
  DIC.PUSH = 'https://tea.push.mding.org/'
}
export default DIC
